import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "modules/AppointmentDetails/components/Interventions/components/PinOverview/components/ImageLetter/ImageLetter.scss";

import type { QuestionResultLetteredImage } from "modules/AppointmentDetails/components/Interventions/components/PinOverview/components/ChecklistSection/hooks";

type ImageLettersProps = {
  letteredImages: QuestionResultLetteredImage[];
};

export const ImageLetters = ({ letteredImages }: ImageLettersProps) => {
  const letters = letteredImages.map(li => li.letterCode).join(",");

  return (
    <div className="ImageLetters">
      <div className="img-icon-wrapper">
        <FontAwesomeIcon icon={faCamera} size="sm" />
        {letters && <span className="report-car-images-letter">{letters}</span>}
      </div>
    </div>
  );
};
